import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const addProduct = async (data: ProductReqT) =>
  axios.post(Routes.ADD_PRODUCT, data);

export const useAddProduct = () =>
  useMutation({
    mutationKey: [Keys.ADD_PRODUCT_MUT],
    mutationFn: addProduct,
  });
